const apiPrefix = process.env.REACT_APP_API_PREFIX;
const api_key = process.env.REACT_APP_APIKEY;

const baseUrl = `${apiPrefix}`;

function buildQueryParams(paramsObj) {
    if(!paramsObj) {
        paramsObj = {};
    }
    const params = new URLSearchParams(
      Object.entries(paramsObj)
        .filter(
          ([, value]) => 
            value !== undefined && 
            value !== null
        )
    )
    params.append('apikey', api_key);
    return params;
}

export { baseUrl, buildQueryParams };